// extracted by mini-css-extract-plugin
export var wordContainer = "_sc-0";